"use client";

import React from "react";
import { Quote, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Adam Knopf",
  quote: "Implementation was smooth and the platform has become essential for our vertical retail growth.",
  position: "Golden State Greens – Vertical Retail"
}, {
  author: "Mike Johnson",
  quote: "The depth of technical expertise in their Metrc API consulting is truly impressive.",
  position: "METRC – API Consulting"
}, {
  author: "Chris DeWeese",
  quote: "An excellent example of how to build a specialized vertical solution on the Salesforce platform.",
  position: "Salesforce Partner Manager"
}];
export default function PassengerSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="19071" id="success-from-the-field" className="bg-muted/30 py-24 overflow-hidden">
      <div ref={ref} className={cn("container mx-auto px-4 max-w-6xl transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-4xl font-bold text-center text-foreground mb-16 tracking-tight">
          Success From the Field
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 gap-y-12 mb-16 px-2">
          {testimonials.map((item, i) => <div key={i} data-index={i} className="relative bg-card rounded-xl p-8 shadow-xl border border-primary/10 flex flex-col h-full">
              {}
              <div className="absolute -top-5 -left-4 bg-card rounded-full p-1 shadow-sm border border-primary/10">
                <Quote className="w-10 h-10 text-primary fill-primary/5" strokeWidth={1.5} />
              </div>

              {}
              <div className="flex-grow mb-6 pt-2">
                <p className="text-foreground font-serif text-lg leading-relaxed italic">
                  "{item.quote}"
                </p>
              </div>

              {}
              <div className="flex flex-col items-center text-center mt-auto border-t border-muted pt-6">
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, starIndex) => <Star key={starIndex} className="w-5 h-5 text-[#10B981] fill-[#10B981]" />)}
                </div>
                <h3 className="text-foreground font-semibold text-lg mb-1 tracking-tight">
                  {item.author}
                </h3>
                <p className="text-muted-foreground font-mono text-xs uppercase tracking-wider">{item.position}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center">
          <Button asChild className="bg-gradient-to-br from-[#1A5A8E] to-[#4092C7] hover:opacity-90 text-white rounded-full px-10 py-6 text-lg font-medium shadow-lg transition-transform hover:scale-105 border-none">
            <Link to="#">View Success Stories</Link>
          </Button>
        </div>
      </div>
    </section>;
}